import { AbstractControl, UntypedFormGroup } from '@angular/forms';

export function getIsRequiredForm(form: UntypedFormGroup, fieldName: string): Boolean {
  try {
    const validator = form.controls[fieldName]?.validator({} as AbstractControl);
    return validator && validator.required;
  } catch (error) {
    return false;
  }
}

export function disabledField(form: UntypedFormGroup, fieldName: string) {
  try {
    form.controls[fieldName]?.disable();
  } catch (error) {
    return false;
  }
}
